import { render } from "./ChatScreen.vue?vue&type=template&id=24ac972c&scoped=true"
import script from "./ChatScreen.vue?vue&type=script&lang=js"
export * from "./ChatScreen.vue?vue&type=script&lang=js"

import "./ChatScreen.vue?vue&type=style&index=0&id=24ac972c&scoped=true&lang=css"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ac972c"]])

export default __exports__